export default "__VITE_ASSET__CunTv2u8__"